import { EnvConfig } from './enums';
import { IFirebaseConfig } from './types';

const firebaseConfigProd = {
  apiKey: 'AIzaSyChnRFBbIqtMIh11hn1iASTEVYOnUyaLZk',
  authDomain: 'motostore-auth.firebaseapp.com',
  projectId: 'motostore-auth',
  storageBucket: 'motostore-auth.appspot.com',
  messagingSenderId: '750249966033',
  appId: '1:750249966033:web:791d4cf03e0a840d0c08f0',
  measurementId: 'G-51RRSQZ0PH',
};

const firebaseConfigStg = {
  apiKey: 'AIzaSyDhblObiwoPpd_fEud3q7f1uotc-rmLeRo',
  authDomain: 'motostore-auth-stg.firebaseapp.com',
  projectId: 'motostore-auth-stg',
  storageBucket: 'motostore-auth-stg.appspot.com',
  messagingSenderId: '759335202358',
  appId: '1:759335202358:web:9a60e76573e523df9ff297',
  measurementId: 'G-F1S4CQYLHY',
};

const firebaseConfigDev = {
  apiKey: 'AIzaSyB8xvkSPAop2SufX5i4ELS7dor807sGOL4',
  authDomain: 'motostore-auth-dev.firebaseapp.com',
  projectId: 'motostore-auth-dev',
  storageBucket: 'motostore-auth-dev.appspot.com',
  messagingSenderId: '535458061052',
  appId: '1:535458061052:web:6dd2096be5e1e78b111579',
  measurementId: 'G-35DR761T1S',
};

export const Config = (): IFirebaseConfig => {
  const env = import.meta.env.VITE_NODE_ENV as EnvConfig;

  switch (env) {
    case EnvConfig.DEV:
      return firebaseConfigDev;

    case EnvConfig.STG:
      return firebaseConfigStg;

    case EnvConfig.PROD:
      return firebaseConfigProd;

    default:
      return firebaseConfigDev;
  }
};

